module.exports = __webpack_public_path__ + "static/media/Sound_listentext.f13018d7.jpg";